import { api } from "@/features/utils/fetch-server";
import type { WebsiteSource, WebsiteSourceInput } from "../types";

export class WebsiteSourcesAPI {
  static list = async (clientId: string): Promise<WebsiteSource[]> =>
    (
      await api.get<{ sources: WebsiteSource[] }>(
        `/api/rag/v1/${clientId}/website-sources`,
      )
    ).sources;

  static create = async (
    clientId: string,
    input: WebsiteSourceInput,
  ): Promise<WebsiteSource> =>
    (
      await api.post<{ source: WebsiteSource }, WebsiteSourceInput | undefined>(
        `/api/rag/v1/${clientId}/website-sources`,
        input,
      )
    ).source;

  static update = async (
    clientId: string,
    id: string,
    input: Partial<WebsiteSourceInput>,
  ): Promise<WebsiteSource> =>
    (
      await api.put<{ source: WebsiteSource }, Partial<WebsiteSourceInput>>(
        `/api/rag/v1/${clientId}/website-sources/${id}`,
        input,
      )
    ).source;

  static refresh = async (
    clientId: string,
    id: string,
  ): Promise<WebsiteSource> =>
    (
      await api.post<{ source: WebsiteSource }, WebsiteSourceInput | undefined>(
        `/api/rag/v1/${clientId}/website-sources/${id}/refresh`,
      )
    ).source;

  static remove = async (
    clientId: string,
    id: string,
  ): Promise<{ success: boolean }> =>
    api.delete(`/api/rag/v1/${clientId}/website-sources/${id}`);
}
